import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import UserProfileModal from "../UserProfileModal";
import search_icn from "../../../assets/Demat/search_icn.svg";
import { Context } from "../../../services/apiContext";
import { useNotificationActionsContext } from "../../../components/notificationModal/useModal";
import configData from "../../../utils/config/config.json";
const DematList = ({ jsondata }) => {
  const [openstatus, setopenstatus] = useState(false);
  const [confirmationName, setconfirmationName] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const [brokerApiList, setBrokerApiList] = useState([]);
  const [selectedName, setselectedName] = useState("");
  const [dematLinksandName, setDematLinksandName] = useState({});
  const [dematMode, setdematMode] = useState("All");
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  const toggleTab = (that) => {
    setdematMode(that);
    getBrokerList(that);
  };
  useEffect(() => {
    getBrokerList("All");
  }, []);
  const openListwithDetails = async (that) => {
    await getBrokerDetails(that.uniq_key).then(() => {
      setshowmodal(true);
      setopenstatus(true);
      setconfirmationName("dematListDetails");
    });
  };
  const closestatus = () => {
    setopenstatus(false);
    setshowmodal(false);

    setconfirmationName("");
  };
  const [searchItem, setsearchItem] = useState("");
  const [searchList, setsearchList] = useState([]);
  const setSearch = (e) => {
    setsearchItem(e.target.value);

    var searched = e.target.value;
    if (searched !== "") {
      let mnsearchList = brokerApiList.filter((item) => {
        return item.broker_name.toLowerCase().includes(searched.toLowerCase());
      });

      setsearchList([...mnsearchList]);
    } else {
      setsearchList([]);
    }
  };
  const getSelecteddata = (that) => {
    console.log(that);
    openListwithDetails(that);
    setsearchList([]);
 setsearchItem('');
  };

  const getBrokerList = async (type) => {
    var postData = {};
    if (type !== "All") {
      postData = {
        data: {
          nsdl: type === "NSDL" ? "Y" : "N",
          cdsl: type === "CDSL" ? "Y" : "N",
        },
        url: configData.baseURLDev + "/demat/brokernames",
      };
    } else {
      postData = {
        data: {
          nsdl: "Y",
          cdsl: "Y",
        },
        url: configData.baseURLDev + "/demat/brokernames",
      };
    }
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === "sucess") {
          setBrokerApiList(res.data.brokers);
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const getBrokerDetails = async (key) => {
    var postData = {
      data: {
        uniq_key: Number(key),
      },
      url: configData.baseURLDev + "/demat/brokerdetails",
    };
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === "sucess") {
          setselectedName(res.data.name);
          setDematLinksandName(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-xs-12 mb-4">
          <div className="addmargindematSearch ">
            <FormControl component="fieldset">
              <RadioGroup
                className="radiowrapperSwitch"
                row
                aria-label="gender"
                name="row-radio-buttons-group"
                value={dematMode}
              >
                <FormControlLabel
                  className={
                    dematMode === "All"
                      ? "RadiodivSwitch radioptionSwitch borderradio "
                      : "RadiodivSwitch radioptionSwitch"
                  }
                  value="All"
                  control={<Radio className="colorchange" />}
                  onChange={() => toggleTab("All")}
                  label="All"
                />
                <FormControlLabel
                  className={
                    dematMode === "NSDL"
                      ? "RadiodivSwitch radioptionSwitch borderradio "
                      : "RadiodivSwitch radioptionSwitch"
                  }
                  value="NSDL"
                  control={<Radio className="colorchange" />}
                  onChange={() => toggleTab("NSDL")}
                  label="NSDL"
                />
                <FormControlLabel
                  className={
                    dematMode === "CDSL"
                      ? "RadiodivSwitch radioptionSwitch borderradio "
                      : "RadiodivSwitch radioptionSwitch"
                  }
                  value="CDSL"
                  control={<Radio className="colorchange" />}
                  onChange={() => toggleTab("CDSL")}
                  label="CDSL"
                />
              </RadioGroup>
            </FormControl>

            <div className="search-box ml-4">
              <img src={search_icn} alt="" title="" />
              <input
                type="text"
                value={searchItem}
                className=""
                onChange={(e) => setSearch(e)}
              />
              {searchList.length > 0 && (
                <div className="customDropdown">
                  {searchList.map((data, i) => (
                    <p onClick={() => getSelecteddata(data)}>
                      {data.broker_name}
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row mobalign">
        <div className="col-md-12 inner-hdng-list">
          <h5>List of Brokerage firms</h5>
        </div>
        <UserProfileModal
          openstatus={openstatus}
          closestatus={closestatus}
          confirmationName={confirmationName}
          TitleName={selectedName}
          dematLinksandName={dematLinksandName}
        />
        <div className="row paddingzero">
          {brokerApiList &&
            brokerApiList.map((data, i) => (
              <div className="col-md-3" key={i}>
                <div className="brokerage-list">
                  <p
                    className="listItems"
                    onClick={() => openListwithDetails(data)}
                  >
                    {data.broker_name}
                  </p>
                </div>
              </div>
            ))}
          {brokerApiList && brokerApiList.length === 0 && <p>No Broker found</p>}
        </div>
      </div>
    </>
  );
};

export default DematList;
